import { render, staticRenderFns } from "./KnightTreasure.vue?vue&type=template&id=6bc25fdf&scoped=true"
import script from "./KnightTreasure.vue?vue&type=script&lang=js"
export * from "./KnightTreasure.vue?vue&type=script&lang=js"
import style0 from "./KnightTreasure.vue?vue&type=style&index=0&id=6bc25fdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc25fdf",
  null
  
)

export default component.exports